import { render, staticRenderFns } from "./VectorizationManagementList.vue?vue&type=template&id=00093490"
import script from "./VectorizationManagementList.vue?vue&type=script&lang=js"
export * from "./VectorizationManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports